export default __webpack_public_path__ + "static/media/meal.16db35f6.jpg";